// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"e3ddf701","453":"1ee5b004"}[chunkId] + ".chunk.js";
};